export const EMOTIONS = [
	"kocicka",
	"kocicka2",
	"krivonozka",
	"myval",
	"myval2",
	"myval3",
	"myval4",
	"myval5",
	"myvalove",
	"opicka",
	"ryba",
	"ryba2",
	"sova",
	"sova2",
	"sova3",
	"sova4",
	"sova5",
	"sova6",
	"sova7",
	"sova8",
	"sova9",
	"sova10",
	"sova11",
	"sova12",
	"hadatko",
	"hrabak",
	"zra",
	"gula",
	"gula2",
	"gula3",
	"kvakalka",
	"bagratko",
	"bagratko2",
	"bagratko3",
	"bagratkotatinek",
	"bobatko",
	"bobatko2",
	"kocicon",
	"kocicon2",
	"kuratko",
	"skupinka",
	"skupinka2",
	"skupinka3",
].sort((aItem, bItem) => {
	const aName = aItem.match(/[a-zA-Z]+/u)[0];
	const aNumberValue = aItem.replace(aName, "");
	const aNumber = aNumberValue ? parseFloat(aNumberValue) : 0;
	const bName = bItem.match(/[a-zA-Z]+/u)[0];
	const bNumberValue = bItem.replace(aName, "");
	const bNumber = bNumberValue ? parseFloat(bNumberValue) : 0;

	if (aName === bName) {
		return aNumber - bNumber;
	}

	return aItem.localeCompare(bItem);
});
